var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":"Search","single-line":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"sort-by":"count","sort-desc":"","search":_vm.search,"dense":"","mobile-breakpoint":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }